import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import { FormEvent, useState } from "react";
import { LanguageDate } from "src/helpers/CheckLanguageDate";
import { makeApiCall } from "src/api/apiRequests";
import DatePicker from "react-datepicker";
import ValidationMessage from "src/helpers/ValidationMessage";
import API_PATHS from "src/api/apiPaths";
import API_HEADERS from "src/api/apiConfig";
import moment from "moment";
import FLASH_MESSAGES from "src/helpers/FlashMessages";

interface AddHolidayProps {
  showModal: boolean;
  setShowModal: (visible: boolean) => void;
  setModified: (visible:boolean)=>void;
}

const AddHoliday: React.FC<AddHolidayProps> = ({
  showModal,
  setModified,
  setShowModal,
}) => {
    const {t}=useTranslation()
    const [btnLoading,setBtnLoading]=useState(false)
    const [date, setDate] = useState<Date | null>(null);
    const [holiday, setHoliday] = useState("");
   const [validations, setValidations] = useState<Record<string, string>>(
         {}
       );
const onClose=()=>{
setShowModal(false)
    }

    const storeHoliday = async (
      e: FormEvent<HTMLFormElement>
      
    ): Promise<void> => {
        e.preventDefault()
        setBtnLoading(true)

        const formData=new FormData()
         formData.append("date", moment(date).format("yyy-MM-DD"));
         formData.append("description", holiday);
      try {
        const response: any = await makeApiCall<ResponseType>(
          API_PATHS.storeHoliday,
          "POST",
          API_HEADERS.authenticated,
          formData
        );
        setBtnLoading(false);
        setModified(true);
        onClose();
        FLASH_MESSAGES.successMsg(response.success);
      } catch (error: any) {
        if (error.response.status === 422) {
          setValidations(error.response.data);
        } else {
          FLASH_MESSAGES.errorMsg(error.response.data.error);
        }
      } finally {
        setBtnLoading(false);
      }
    };


  return (
    <>
      <Modal isOpen={showModal} toggle={() => onClose()} centered size="md">
        <form onSubmit={(e) => storeHoliday(e)}>
          <ModalHeader toggle={() => onClose()}>
            {t("add_holiday_popup_title")}
          </ModalHeader>
          <ModalBody>
            <div className="modal-note mb-4">
              {t("holiday_add_new_subtitle")}
            </div>
            <div className="form-block col-12  ">
              <label className="required">{t("holiday_date_label")}</label>
              <DatePicker
                selected={date}
                onChange={(e) => setDate(e)}
                showMonthDropdown
                showYearDropdown
                dateFormat="dd-MM-yyyy"
                placeholderText={t("holiday_date_placeholder")}
                className={
                  "form-datepicker" + (validations.date ? " input-error" : "")
                }
                autoComplete="off"
                name="date_start"
                // maxDate={new Date()}
                locale={LanguageDate.datepicker}
              />
              {validations.date && (
                <ValidationMessage message={validations.date[0]} />
              )}
            </div>
            <div className="form-block col-12 ">
              <label className="required">{t("holiday_label")}</label>
              <textarea
                name="description"
                className={
                  "form-input " +
                  (validations.description ? " input-error" : "")
                }
                value={holiday}
                placeholder={t("holiday_placeholder")}
                rows={6}
                onChange={(e) => setHoliday(e.target.value)}
              />
              {validations.description && (
                <ValidationMessage message={validations.description[0]} />
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className="button-white"
              type="button"
              onClick={() => onClose()}
            >
              {t("meal_edit_assortment_cancel_button")}
            </button>
            {btnLoading ? (
              <button className="button-blue has-icon" type="button">
                <i className="icon spinner-icon" />
                {t("add_staff_saving")}
              </button>
            ) : (
              <button className="button-blue has-icon" type="submit">
                <i className="icon plus-icon" />
                {t("add_staff_save")}
              </button>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
};
export default AddHoliday;
